module.exports = __webpack_public_path__ + "img/bg_visuality.45a61b2e.jpg";